import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { HTTPResponseError, PromocodeNotFoundError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  promoCode: string;
  isPartner: boolean;
};

export const checkPromocode = async (params: Params) => {
  const fetchURL = getM8AuthURL('checkPromocode');

  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    if (response.status === 404) {
      throw new PromocodeNotFoundError();
    }

    throw new HTTPResponseError(response);
  }
};
